// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-profile .split-right .dateTime {
  position: relative;
}
.student-profile .split-right .dateTime i {
  position: absolute;
  left: 15px;
  top: 12px;
  font-size: 15px;
  z-index: 1;
}
.student-profile .split-right .rdt .form-control {
  padding-left: 40px;
}
.student-profile .split-right .rdt.rdtOpen .rdtPicker {
  width: 180px;
}
.student-profile .split-right .rdtPicker {
  right: 0;
}
.student-profile .card.profile-card {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.0509803922);
  border: none;
  border-radius: 6px;
}
.student-profile .card.profile-card .split-left button {
  color: #ced4da;
}
.student-profile .card.profile-card .nav-pills .nav-item {
  margin-right: 20px;
}
.student-profile .card.profile-card .nav-pills .nav-item .nav-link {
  position: relative;
  color: #212124;
  border: none;
  padding: 0.35rem;
  border-radius: 0 !important;
  transition: all 0.1s;
}
.student-profile .card.profile-card .nav-pills .nav-item .nav-link:hover {
  border-radius: 0 !important;
  background-color: transparent;
  border-bottom: 2px solid #36A1F5;
}
.student-profile .card.profile-card .nav-pills .nav-item .nav-link.active {
  font-weight: 600;
  border-radius: 0 !important;
  background-color: transparent;
  border-bottom: 2px solid #36A1F5;
}
.student-profile .card.profile-card .nav-pills .nav-item:last-child {
  margin-right: 0;
}

.student_footer {
  position: relative;
  background: #333333;
}
@media (max-width: 767px) {
  .student_footer {
    text-align: center;
  }
}
.student_footer .footer-top {
  background: #393939;
}
.student_footer .footer-top .import-link li {
  margin-right: 2rem;
}
.student_footer .footer-top .import-link li:last-child {
  margin-right: 0;
}
.student_footer .footer-top .social-list li {
  margin-right: 1rem;
}
.student_footer .footer-top .social-list li:last-child {
  margin-right: 0;
}
.student_footer .footer-middle .import-link2 li {
  margin-right: 3rem;
}
.student_footer .footer-middle .import-link2 li:last-child {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/student_organization_profile/_studentprofile.scss"],"names":[],"mappings":"AAIQ;EACI,kBAAA;AAHZ;AAKY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAHhB;AAOQ;EACI,kBAAA;AALZ;AAQQ;EACI,YAAA;AANZ;AASQ;EACI,QAAA;AAPZ;AAWI;EACI,oDAAA;EACA,YAAA;EACA,kBAAA;AATR;AAYY;EACI,cAAA;AAVhB;AAcQ;EACI,kBAAA;AAZZ;AAcY;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;AAZhB;AAegB;EACI,2BAAA;EACA,6BAAA;EACA,gCAAA;AAbpB;AAgBgB;EACI,gBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AAdpB;AAkBY;EACI,eAAA;AAhBhB;;AAsBA;EACI,kBAAA;EACA,mBAAA;AAnBJ;AAqBI;EAJJ;IAKQ,kBAAA;EAlBN;AACF;AAoBI;EACI,mBAAA;AAlBR;AAoBQ;EACI,kBAAA;AAlBZ;AAoBY;EACI,eAAA;AAlBhB;AAsBQ;EACI,kBAAA;AApBZ;AAsBY;EACI,eAAA;AApBhB;AA0BQ;EACI,kBAAA;AAxBZ;AA0BY;EACI,eAAA;AAxBhB","sourcesContent":[".student-profile {\n\n    .split-right {\n\n        .dateTime {\n            position: relative;\n\n            i {\n                position: absolute;\n                left: 15px;\n                top: 12px;\n                font-size: 15px;\n                z-index: 1;\n            }\n        }\n\n        .rdt .form-control {\n            padding-left: 40px;\n        }\n\n        .rdt.rdtOpen .rdtPicker {\n            width: 180px;\n        }\n\n        .rdtPicker {\n            right: 0;\n        }\n    }\n\n    .card.profile-card {\n        box-shadow: 0px 0px 20px #0000000D;\n        border: none;\n        border-radius: 6px;\n\n        .split-left {\n            button {\n                color: #ced4da;\n            }\n        }\n\n        .nav-pills .nav-item {\n            margin-right: 20px;\n\n            .nav-link {\n                position: relative;\n                color: #212124;\n                border: none;\n                padding: 0.35rem;\n                border-radius: 0 !important;\n                transition: all 0.1s;\n\n\n                &:hover {\n                    border-radius: 0 !important;\n                    background-color: transparent;\n                    border-bottom: 2px solid #36A1F5;\n                }\n\n                &.active {\n                    font-weight: 600;\n                    border-radius: 0 !important;\n                    background-color: transparent;\n                    border-bottom: 2px solid #36A1F5;\n                }\n            }\n\n            &:last-child {\n                margin-right: 0;\n            }\n\n        }\n    }\n}\n.student_footer {\n    position: relative;\n    background: #333333;\n\n    @media (max-width: 767px) {\n        text-align: center;\n    }\n\n    .footer-top {\n        background: #393939;\n\n        .import-link li {\n            margin-right: 2rem;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n\n        .social-list li {\n            margin-right: 1rem;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n\n    .footer-middle {\n        .import-link2 li {\n            margin-right: 3rem;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
